// extracted by mini-css-extract-plugin
module.exports = {"target":"popover-module--target--3sUOz","contentWrapper":"popover-module--contentWrapper--cgcKU","content":"popover-module--content--qECqt"};